// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".roleinfo-container[data-v-4cb2673e] {\n  padding: 0.052083rem;\n}\n[data-v-4cb2673e] .el-dialog {\n  margin-top: 0.052083rem !important;\n}", "",{"version":3,"sources":["D:/source/2000HuiTian/huitianadmin/<input css 40>"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AAEA;EACE,kCAAkC;AACpC","file":"RolePage.vue","sourcesContent":[".roleinfo-container {\n  padding: 0.052083rem;\n}\n\n/deep/.el-dialog {\n  margin-top: 0.052083rem !important;\n}"]}]);
// Exports
module.exports = exports;
